export enum REDIRECT_ROUTES {
    ACCESS_TOKENS = '/account/access-tokens',
    AUDIT = '/account/audit',
    PERSONAL_DETAILS = '/account/personal-details',
    NO_PERMISSIONS = '/no-permissions',
    WELCOME_PAGE = '/dashboard/welcome',
}

export const ACCOUNT_ROUTES: string[] = [REDIRECT_ROUTES.ACCESS_TOKENS, REDIRECT_ROUTES.AUDIT];
